




























































import { Component, Vue} from 'vue-property-decorator'; // デコレータ
import { organizationModule } from '../store/modules/Organization';
import router from '../../router';
import { routingControlModule } from '../../store/modules/RoutingControl'; // ルーティング制御モジュール
import { KnariScreenName } from '../fixed/KanriScreenName';

@Component
export default class OrganizationMenu extends Vue {
  private created() {
    organizationModule.moduleReset();
  }
  private returnPrevious() {
    router.push({name: KnariScreenName.KANRI_TOP});
  }

  private toInfo() {
    routingControlModule.registPrevious(this.$route.name);
    router.push({name: KnariScreenName.ORGANIZATION_INFO});
  }
}
